import _ from 'lodash';
import { getField, updateField } from 'vuex-map-fields';
const state = {
    clientes: []
};
const mutations = {
    updateField,
    updateClientes: (state, payload) => {
        state.clientes = payload;
    }
};
const getters = {
    getField,
};
export default {
    namespaced: true,
    state,
    mutations,
    getters
}
